export const RAW_PACKING_REQUEST = "RAW_PACKING_REQUEST";
export const RAW_PACKING_SUCCESS = "RAW_PACKING_SUCCESS";
export const RAW_PACKING_FAILED = "RAW_PACKING_FAILED";